import React, { Component } from 'react';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import axios from 'axios';

const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

class ExcelReader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			file: {},
			data: [],
			cols: [],
			gameList: [],
			assetTypeList: [],
			max_row: 0,
			assetCount: 0,
			currentSheet: 0,
			sheetData: null,
			countPerSheet: 0,
			sendRequest: 0,
			receiveRequest: 0
		}
		this.handleFile = this.handleFile.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.getGameList = this.getGameList.bind(this);
		this.getAssetTypeList = this.getAssetTypeList.bind(this);
		this.getGameId = this.getGameId.bind(this);
	}

	componentDidMount() {
		this.getGameList();
		this.getAssetTypeList();
	}

	getGameList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getGameList')
			.then(response => {
				if ( response.status === 200 ) {
					var gameList = [];

					for (var i=0; i<response.data.length; i++) {
						gameList.push({ value: response.data[i].id, label: response.data[i].name });
					}

					this.setState({
						gameList: gameList
					});
				}
			})
	}

	getAssetTypeList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getAssetTypeList')
			.then(response => {
				if ( response.status === 200 ) {
					var assetTypeList = [];
					var max_id = 0;

					for (var i=0; i<response.data.length; i++) {
						assetTypeList.push({ value: response.data[i].id, label: response.data[i].name });						
						if (max_id < response.data[i].id) {
							max_id = response.data[i].id;
						}
					}

					this.setState({
						assetTypeList: assetTypeList,
						max_row: max_id
					});
				}
			})
	}
 
	handleChange(e) {
		const files = e.target.files;
		if (files && files[0]) this.setState({ file: files[0] });
	};
 
	handleFile() {
		/* Boilerplate to set up FileReader */
		const reader = new FileReader();
		const rABS = !!reader.readAsBinaryString;
 
		reader.onload = (e) => {
			/* Parse data */
			const bstr = e.target.result;
			const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
			/* Get first worksheet */

			this.setState({
				sheetData: wb
			}, function(){
				this.sendAssetData();
			})
		};
 
		if (rABS) {
			reader.readAsBinaryString(this.state.file);
		} else {
			reader.readAsArrayBuffer(this.state.file);
		};
	}

	async sendAssetData(){
		// for (var i=0; i<this.state.sheetData.SheetNames.length; i++) {
		// 	console.log(i + " : " + this.state.sheetData.SheetNames[i]);
		// }

		console.log("max_row = " + this.state.max_row);

		const wsname = this.state.sheetData.SheetNames[this.state.currentSheet];
		const ws = this.state.sheetData.Sheets[wsname];
		var sendRequest = 0;

		console.log("========= " + this.state.currentSheet + " : " + wsname + " =========");

		const data = XLSX.utils.sheet_to_json(ws);

		var availableRowCount = 0;

		for (var j=0; j<data.length; j++) {
			var asset = data[j];
			if (asset["Asset Name"]) {
				var gameId = this.getGameId(wsname);
				if (gameId) {
					availableRowCount++;
				}
			}
		}

		console.log("availableRowCount = " + availableRowCount);
		if (availableRowCount == 0) {
			console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX");

			this.setState({
				currentSheet: this.state.currentSheet + 1,
				countPerSheet: 0
			}, function(){
				if (this.state.currentSheet < this.state.sheetData.SheetNames.length) {
					console.log("going next sheet");
					this.sendAssetData();
				}
			})
		}

		for (var j=0; j<data.length; j++) {
			let currentIndex = j;

			var asset = data[j];

			var rarity = "0";
			if (asset["Rarity"]) {
				rarity = asset["Rarity"];
			}

			if (asset["Asset Name"]) {
				var gameId = this.getGameId(wsname);
				var count = 0;

				var assetTypeId = this.getAssetTypeId(asset["AssetType1"]);
				var mainImageUrl = "";
				if (asset["MainImageUrl"]) {
					mainImageUrl = asset["MainImageUrl"];
				}

				if (gameId) {
					const assetData = {
								userId: 11,
								assetName: asset["Asset Name"],
								gameId: gameId,
								assetType: assetTypeId,
								assetTypeName: asset["AssetType1"],
								rarity: rarity,
								enhancementList: [],
								enhancementValues: [],
								currencyId: 0,
								price: 0,
								description: '',
								videoIdList: [],
								mainImageUrl: asset["MainImageUrl"]
							};

					axios.defaults.withCredentials = true;
					
					axios.post(window.$backend_url + '/add_asset_new', assetData)
						.then(response => {
							this.setState({
								countPerSheet: this.state.countPerSheet + 1
							}, function(){
								if (this.state.countPerSheet == availableRowCount) {
									console.log(wsname + " countPerSheet = " + this.state.countPerSheet);

									this.setState({
										currentSheet: this.state.currentSheet + 1,
										countPerSheet: 0
									}, function(){
										if (this.state.currentSheet < this.state.sheetData.SheetNames.length) {
											console.log("going next sheet");
											this.sendAssetData();
										}
									})
								}
							})
						})

					await sleep(30);
					
				} else {
				}
			} else {
			}
		}
	}

	getAssetTypeId(assetTypeName) {
		if (assetTypeName) {
			const filteredOptions = this.state.assetTypeList.filter(
				(assetType) =>
				assetType.label.toLowerCase() == assetTypeName.toLowerCase()
			);

			if (filteredOptions.length) {
				return filteredOptions[0].value;
			} else {
				var max_row = this.state.max_row;
				max_row++;
				var temp = this.state.assetTypeList;
				temp.push({value: max_row, label: assetTypeName});

				this.setState({
					max_row: max_row,
					assetTypeList: temp
				})

				return -max_row;
			}
		} else {
			return 0;
		}
	}

	getGameId(gameName){
		gameName = gameName.toString().trim();
		if (gameName == "Elder Scroll") {
			return 42;
		} else if (gameName == "COD : WWII") {
			return 30;
		} else if (gameName == "Rainbow 6 Seige") {
			return 21;
		} else if (gameName == "Black Desert") {
			return 45;
		} else if (gameName == "Guild Wars") {
			return 41;
		} else if (gameName == "Final Fantasy") {
			return 37;
		} else if (gameName == "Blade and Soul") {
			return 33;
		} else if (gameName == "GTA") {
			return 25;
		} else if (gameName == "DC Universe") {
			return 31;
		} else if (gameName == "PayDay") {
			return 34;
		} else if (gameName == "APEX") {
			return 29;
		} else if (gameName == "Maple Story") {
			return 9;
		} else if (gameName == "CSGO") {
			return 22;
		} else if (gameName == "Call of Duty WWII") {
			return 30;
		} else if (gameName == "Fate Grand Order") {
			return 59;
		} else if (gameName == "FF XV A New Empire") {
			return 54;
		}

		const filteredOptions = this.state.gameList.filter(
			(game) =>
			game.label.toLowerCase() == gameName.toLowerCase()
		);

		if (filteredOptions.length) {
			return filteredOptions[0].value;
		} else {
			return 0;
		}
		
	}
 
	render() {
		return (
			<div>
				<label htmlFor="file">Upload an excel to Process Triggers</label>
				<br />
				<input type="file" className="form-control" id="file" accept={SheetJSFT} onChange={this.handleChange} />
				<br />
				<input type='submit' 
					value="Process Triggers"
					onClick={this.handleFile} />
					</div>
			
		)
	}
}
 
export default ExcelReader;


// WEBPACK FOOTER //
// ./src/components/ExcelReader.js